import { useEffect } from 'react';

interface PageMetaOptions {
  canonical?: string;
  noIndex?: boolean;
}

export function usePageMeta({ canonical, noIndex = false }: PageMetaOptions = {}): void {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL as string | undefined;
    const base = siteUrl ? siteUrl.replace(/\/$/, '') : '';

    // --- Canonical ---
    const canonicalHref = canonical ? `${base}${canonical}` : null;
    let canonicalEl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const prevHref = canonicalEl?.href ?? null;

    if (canonicalHref) {
      if (!canonicalEl) {
        canonicalEl = document.createElement('link');
        canonicalEl.rel = 'canonical';
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.href = canonicalHref;
    }

    // --- Robots / noindex ---
    let robotsMeta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (noIndex) {
      if (!robotsMeta) {
        robotsMeta = document.createElement('meta');
        robotsMeta.name = 'robots';
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.content = 'noindex, nofollow';
    }

    return () => {
      // Restore canonical to home
      const el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (el && prevHref !== null) {
        el.href = prevHref;
      }
      // Remove noindex meta
      if (noIndex) {
        document.querySelector<HTMLMetaElement>('meta[name="robots"]')?.remove();
      }
    };
  }, [canonical, noIndex]);
}
